import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardResponseDto } from "../../shared/dtos/dashboard/DashboardResponseDto";

export interface DashboardState {
  stats: DashboardResponseDto | null;
  loadingStats: boolean;
  errorLoadingStats: string | null;

  trackingActivity: boolean;
  errorTrackingActivity: string | null;
}

const initialState: DashboardState = {
  stats: null,
  loadingStats: false,
  errorLoadingStats: null,

  trackingActivity: false,
  errorTrackingActivity: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoadingStats(state) {
      state.loadingStats = true;
      state.errorLoadingStats = null;
    },
    setStats(state, action: PayloadAction<DashboardResponseDto>) {
      state.loadingStats = false;
      state.stats = action.payload;
    },
    setErrorLoadingStats(state, action: PayloadAction<string | null>) {
      state.loadingStats = false;
      state.errorLoadingStats = action.payload;
    },

    setTrackingActivity(state) {
      state.trackingActivity = true;
      state.errorTrackingActivity = null;
    },
    setTrackingSuccess(state) {
      state.trackingActivity = false;
    },
    setErrorTrackingActivity(state, action: PayloadAction<string | null>) {
      state.trackingActivity = false;
      state.errorTrackingActivity = action.payload;
    },
  },
});

export const dashboardActions = dashboardSlice.actions;
export default dashboardSlice.reducer;
